
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State } from '../reducers/memberFormConfig.reducers';

export const selectDataState = createFeatureSelector<State>('memberFormConfigData');

export const selectMemberFormConfigData = createSelector(selectDataState, (state) => state.memberFormConfigData);
export const selectMemberFormConfigLoading = createSelector(selectDataState, (state) => state.loading);
export const selectMemberFormConfigError = createSelector(selectDataState, (state) => state.error);
